// only allow "." and "_" as special characters
export const specialCharacters = /[ `!@#$%^&*()+\-=\[\]{};':"\\|,<>\/?~]/
